import { render, staticRenderFns } from "./ExamPoint.vue?vue&type=template&id=6b2eb88a&scoped=true"
import script from "./ExamPoint.vue?vue&type=script&lang=js"
export * from "./ExamPoint.vue?vue&type=script&lang=js"
import style0 from "./ExamPoint.vue?vue&type=style&index=0&id=6b2eb88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2eb88a",
  null
  
)

export default component.exports